import PropTypes from 'prop-types';
/* eslint-disable no-did-mount-set-state */
import React from 'react';
import { Modal } from 'semantic-ui-react';
import ModalHeader from './Header';
import ModalContent from './Content';
import styles from './Modal.scss';

export default class MobileModal extends React.Component {

  static propTypes = {
    inline: PropTypes.bool
  }

  static Header = ModalHeader;
  static Content = ModalContent;

  constructor(props) {
    super(props);
    this.state = {
      mounted: false
    };
  }

  componentDidMount() {
    this.mounted();
  }

  mounted() {
    this.setState({ mounted: true });
  }

  render() {
    const { inline, ...rest } = this.props;
    return ([
      <span
        ref='mountNode'
        key='mountNode'
        className='dthcIgnoreOnClickOutside'
      />,
      this.state.mounted &&
        <Modal
          key='modal'
          dimmer='inverted'
          className={styles.mobileModal}
          mountNode={inline ? this.refs.mountNode : document.body}
          {...rest}
        />
    ]);
  }

}



// WEBPACK FOOTER //
// ./webpack/components/Modules/MobileModal/Modal.js